/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import { getFormsHostForDataCenter } from 'cio/utils/data-centers';
import config from 'cio/config/environment';

interface FormsCustomIntegrationDetailsJsSnippetDetailsArgs {
  onCopy: () => unknown;
  credentials?: {
    siteId?: string;
    apiKey?: string;
  };
}

export default class FormsCustomIntegrationDetailsJsSnippetDetails extends Component<FormsCustomIntegrationDetailsJsSnippetDetailsArgs> {
  @service account!: AccountService;

  get apiBaseURL() {
    return getFormsHostForDataCenter(this.account.current?.dataCenter) ?? '';
  }

  get jsBaseURL() {
    if (config.isProduction || config.isProdStaging) {
      // same base URL as for API calls in prod:
      return this.apiBaseURL;
    }

    // fallback to staging forms.js in all other envs:
    return 'https://staging.customerioforms.com';
  }

  get snippet() {
    return `
<script type="text/javascript">
  (function() {
    var t = document.createElement('script'),
        s = document.getElementsByTagName('script')[0];
    t.async = true;
    t.id    = 'cio-forms-handler';
    t.setAttribute('data-site-id', '${this.args.credentials?.siteId ?? 'siteid'}');
    t.setAttribute('data-base-url', '${this.apiBaseURL}');

    t.src = '${this.jsBaseURL}/assets/forms.js';

    s.parentNode.insertBefore(t, s);
  })();
</script>
`.trim();
  }
}
